import React from "react";
import { useNavigate, useRouteLoaderData } from "react-router-dom";
import { Button, Stack } from "@mui/material";
import TabLayout from "../../helpers/TabLayout";
import {
  sessionUpdate,
  sessionUpdateShortDescription,
} from "../../../api/session";
import useInfoSnackbar from "../../../hooks/useInfoSnackbar";
import useEditObject from "../../../hooks/useEditObject";
import EditableField from "../helpers/EditableField";

const SettingsForm = () => {
  const loaderData = useRouteLoaderData("profileComponent");
  const userEntity = loaderData.userEntityRes?.data;
  const shortDescription = loaderData.shortDescriptionRes?.data;
  const { editObject, editHandler: handleFieldChange } = useEditObject();

  const infoSnackbar = useInfoSnackbar();
  const navigate = useNavigate();

  const handleSave = async (event) => {
    event.preventDefault();
    const response = await sessionUpdate({
      ...userEntity,
      ...editObject.current,
    });
    if (response.code === "SUCCESS") {
      loaderData.userEntityRes.data = { ...userEntity, ...editObject.current };
      if (editObject.current.shortDescription !== undefined) {
        await sessionUpdateShortDescription(
          editObject.current.shortDescription);
        loaderData.shortDescriptionRes.data = editObject.current.shortDescription;
      }
      infoSnackbar.alertSuccess(response.message);
      navigate("../");
      if (editObject.current.firstName !== undefined) {
        window.location.reload();
      }
    } else {
      infoSnackbar.alertError(response.message);
    }
  };

  const handleCancel = () => navigate("/profile/settings");

  return (
    <TabLayout skeletonLines={30}>
      <Stack
        component="form"
        onSubmit={handleSave}
        method="POST"
        alignItems="center"
      >
        <Stack
          spacing={4}
          width="80%"
          pt={2}
          pb={8}
        >
          <EditableField
            label="First Name"
            type="text"
            id="firstName"
            name="firstName"
            required={false}
            isEditable
            initialValue={userEntity?.firstName}
            onChange={handleFieldChange}
            variant="outlined"
          />
          <EditableField
            label="Last Name"
            type="text"
            id="lastName"
            name="lastName"
            required={false}
            isEditable
            initialValue={userEntity?.lastName}
            onChange={handleFieldChange}
            variant="outlined"
          />
          <EditableField
            label="Phone Number"
            type="text"
            id="phone"
            name="phone"
            required={false}
            isEditable
            initialValue={userEntity?.phone}
            onChange={handleFieldChange}
            variant="outlined"
          />
          <EditableField
            label="Short Description"
            type="text"
            id="shortDescription"
            name="shortDescription"
            required={false}
            isEditable
            initialValue={shortDescription}
            onChange={handleFieldChange}
            multiline
            rows={3}
            variant="outlined"
          />
          <EditableField
            label="LinkedIn"
            type="text"
            id="linkedinUserId"
            name="linkedinUserId"
            required={false}
            isEditable
            initialValue={userEntity?.linkedinUserId}
            onChange={handleFieldChange}
            variant="outlined"
          />
          <EditableField
            label="Facebook"
            type="text"
            id="facebookUserId"
            name="facebookUserId"
            required={false}
            isEditable
            initialValue={userEntity?.facebookUserId}
            onChange={handleFieldChange}
            variant="outlined"
          />
          <EditableField
            label="Gmail"
            type="text"
            id="gmailUserId"
            name="gmailUserId"
            required={false}
            isEditable
            initialValue={userEntity?.gmailUserId}
            onChange={handleFieldChange}
            variant="outlined"
          />
          <EditableField
            label="Skype"
            type="text"
            id="skypeUserId"
            name="skypeUserId"
            required={false}
            isEditable
            initialValue={userEntity?.skypeUserId}
            onChange={handleFieldChange}
            variant="outlined"
          />
        </Stack>
        <Stack
          justifyContent="center"
          direction="row"
          gap={2}
        >
          <Button
            variant="contained"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
          >
            Save
          </Button>
        </Stack>
      </Stack>
    </TabLayout>
  );
};

export default SettingsForm;